import React from 'react'
import { Learn } from '@/features'
import { APIClient } from '@/services'

export function useLessonLoader(params: Learn.T.LessonLoaderParams) {
  const { id, chapter, module, pages } = params

  const pagesQuery = APIClient.Learn.pagesManager.useList({
    filter: { chapter: id, include_question: true },
    queryOptions: { initialData: pages as any }
  })

  const chapterQuery = APIClient.Learn.chaptersManager.useItem({
    id,
    queryOptions: { initialData: chapter }
  })

  const moduleQuery = APIClient.Learn.modulesManager.useItem({
    id: chapterQuery.data?.module,
    queryOptions: {
      enabled: Boolean(chapterQuery.data?.module),
      initialData: module
    }
  })

  React.useEffect(() => {
    Learn.S.lesson.set({
      pages: pagesQuery.items,
      chapter: chapterQuery.data,
      module: moduleQuery.data
    })
  }, [pagesQuery.items, chapterQuery.data, moduleQuery.data])

  const loading = pagesQuery.query.isLoading || chapterQuery.query.isLoading || moduleQuery.query.isLoading
  const error = pagesQuery.query.error || chapterQuery.query.error || moduleQuery.query.error
  const isReady = !loading && !error

  return {
    loading,
    error,
    isReady,
    queries: {
      pages: pagesQuery,
      chapter: chapterQuery,
      module: moduleQuery
    }
  }
}

export type UseLessonLoader = ReturnType<typeof useLessonLoader>
